import { Component, HostListener, inject } from '@angular/core';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { FactorModel } from 'src/app/models/factor.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { NgClass } from '@angular/common';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { FactorModalComponent } from './factor-modal/factor-modal.component';

import { MatButtonModule } from '@angular/material/button';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-factor',
    templateUrl: './factor.component.html',
    styleUrls: ['./factor.component.scss'],
    imports: [IconMenuButtonComponent, MatMenu, MatMenuItem, NgClass, MatIcon, FactorModalComponent, MatButtonModule, PageHeaderComponent, EmptyStateComponent]
})
export class FactorComponent {
  private readonly factorSvc = inject(SupplierService);
  toastr = inject(ToastService);


  factors: FactorModel[] = [];
  showFactorModal: boolean = false;
  selectedFactor?: FactorModel;

  ngOnInit() {
    this.getFactors();
  }

  getFactors() {
    this.factorSvc.getAllFactors().subscribe({
      next: (data) => {
        this.factors = data;
      },
    });
  }

  openModal(level?: FactorModel) {
    this.showFactorModal = true;
    this.selectedFactor = level;
  }

  deleteFactor(id: string) {
    this.SwalFireQuestion(
      'Eliminar factor',
      '¿Está seguro que desea eliminar el factor?'
    ).then((result) => {
      if (result.isConfirmed) {
        this.factorSvc.deleteFactor(id, false).subscribe({
          next: (result) => {
            this.toastr.success(
              'Factor eliminado',
              'El factor se ha eliminado correctamente.'
            );
            this.getFactors();
          },
          error: (err) => {
            this.toastr.error('Error', 'No se pudo eliminar el factor.');
          },
        });
      }
    });
  }

  SwalFireQuestion(title: string, text: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      html: `<div class="swal2-content-custom">${text}</div>`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      confirmButtonColor: '#E61414',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#FFF',
      customClass: {
        title: 'swal2-title-custom',
        popup: 'swal2-popup-custom',
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom',
        actions: 'swal2-actions-custom',
      },
      reverseButtons: true,
    });
  }

  @HostListener('window:keydown.escape', ['$event'])
  backToScore(event?: KeyboardEvent) {
    this.showFactorModal = false;
  }
}
